import React from 'react';
import styles from './Avatar.module.sass';
import cn from 'classnames';
import { useAuth } from 'hooks/useAuth';
import Icon from '../Icon';

export interface AvatarProps
  extends React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > {
  type: 'circle' | 'square';
  className?: string;
  onClick?: () => void;
  src?: string;
  localUser?: boolean;
}

const Avatar: React.FC<AvatarProps> = ({
  type,
  className,
  onClick,
  src,
  localUser,
  ...imgProps
}) => {
  const { authProfile } = useAuth();
  const imgSrc =
    localUser && authProfile ? authProfile.user.profilePicture : src;

  return (
    <div
      className={cn(styles.avatar, styles[type], className)}
      onClick={onClick}
    >
      {typeof imgSrc === 'string' ? (
        <img {...imgProps} alt="user-picture" src={imgSrc} />
      ) : (
        <div>
          <Icon name="user-outline" />
        </div>
      )}
    </div>
  );
};

export default Avatar;
